module.exports = __webpack_public_path__ + "img/stickers-ODP.6e11c1c4.jpg";